<div class="Txt-Withdraw-Coinbase withdraw-dialog">
  <div class="paypal-header">
    <div class="paypal-text">{{ 'PAYOUT' | t }}</div>
    <div class="close-svg" (click)="closeDialog()"></div>
  </div>
  <div class="paypal-container">
    <div class="paypal-icon-container">
      <image-loader-utils [url]="selectedWithdraw.withdrawName.toLowerCase()" extraClasses="icon  payment-modal-icon"></image-loader-utils>
    </div>
    <div class="paypal-balance-text">
      <h2>{{ 'Balance' | t }} {{ this._UserHelper.customerUser?.Balance }}</h2>
    </div>

    <form class="example-form" [formGroup]="WithdrawFormDatas">
      <div class="credit-input-container">
        <inputb3
          [extraClass]="'amountInput'"
          fPlaceholder="{{ 'Amount' | t }}"
          fInputType="number"
          fSuffixText="{{ this._UserHelper.customerUser.Symbol }}"
          formControlName="withdrawamount"
          [disabled]="true"></inputb3>
        <ng-template #mailForm>
          <inputb3 fPlaceholder="{{ 'e_mail_address' | t }}" fInputType="email" formControlName="mailadress" [extraClass]="'amountInput'"></inputb3>
        </ng-template>

        <inputb3
          *ngIf="this.selectedWithdraw.withdrawTypeId === 73; else mailForm"
          fPlaceholder="{{ 'Phone_Number' | t }}"
          fInputType="number"
          formControlName="phoneNumber"
          [extraClass]="'amountInput'"></inputb3>
      </div>
    </form>
    <div class="confirm-button-container" *ngIf="WithdrawFormDatas.valid; else noAmount" (click)="submitWithdraw()">
      <!-- <div class="alert-message" *ngIf="alertMessage">
        {{ alertMessageDesc }}
      </div> -->

      <div class="btn colored register-button save-changes-button confirm-button">
        <div class="btn-text">{{ 'Confirm' | t }}</div>
      </div>
    </div>

    <ng-template #noAmount>
      <div class="confirm-button-container">
        <!-- <div class="alert-message" *ngIf="alertMessage">
          {{ alertMessageDesc }}
        </div> -->

        <div style="opacity: 0.5" class="btn colored register-button save-changes-button confirm-button opacity">
          <div class="btn-text">{{ 'Confirm' | t }}</div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
